import React, { createContext } from 'react';
const CascadeDropdownContext = createContext({});
export function CascadeDropdownProvider({ children, value, }) {
    return (React.createElement(CascadeDropdownContext.Provider, { value: value }, children));
}
export function useCascadeDropdownContext() {
    const context = React.useContext(CascadeDropdownContext);
    if (context === undefined) {
        throw new Error('useCascadeDropdownContext must be used within a CascadeDropdownProvider');
    }
    return context;
}
//# sourceMappingURL=useCascadeDropdownContext.js.map